import StarRating from './star-rating.vue'

export default StarRating



// WEBPACK FOOTER //
// ./src/index.js